import { Button, ButtonProps, forwardRef } from '@chakra-ui/react'

export const CancelButton = forwardRef((props: ButtonProps, ref) => (
  <Button ref={ref} variant="ghost" size="sm" mr={3} children="Cancel" {...props} />
))
